var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-navbar",
        {
          attrs: { id: "header", type: "light", variant: "light", sticky: "" }
        },
        [
          _c("b-navbar-nav", [
            _c("h4", { staticClass: "mb-0" }, [_vm._v(_vm._s(_vm.title))])
          ]),
          _vm._v(" "),
          _c(
            "b-navbar-nav",
            { staticClass: "ml-auto" },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            id: "view-button",
                            size: "sm",
                            variant: "warning"
                          },
                          on: { click: _vm.toggleView }
                        },
                        [
                          _c("font-awesome-icon", {
                            attrs: {
                              icon:
                                _vm.viewMode === "table" ? "th-large" : "list"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "view-button",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.viewMode === "table" ? "Канбан" : "Таблица"
                              ) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-toggle",
                              rawName: "v-b-toggle.sidebar-fields",
                              modifiers: { "sidebar-fields": true }
                            }
                          ],
                          staticClass: "mr-2",
                          attrs: {
                            id: "table-settings",
                            size: "sm",
                            variant: "warning"
                          }
                        },
                        [_c("font-awesome-icon", { attrs: { icon: "cog" } })],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-tooltip",
                        {
                          attrs: {
                            target: "table-settings",
                            triggers: "hover",
                            variant: "warning",
                            noninteractive: ""
                          }
                        },
                        [_vm._v("\n            Колонки\n          ")]
                      ),
                      _vm._v(" "),
                      _vm.canEditRecruitJobPostings()
                        ? _c(
                            "b-btn",
                            {
                              attrs: {
                                size: "sm",
                                variant: "success",
                                disabled: _vm.isBusy
                              },
                              on: {
                                click: function($event) {
                                  return _vm.showModal(null, false)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "plus" }
                              }),
                              _vm._v("\n            Новая\n          ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-navbar",
        { attrs: { variant: "light" } },
        [
          _c(
            "b-navbar-nav",
            [
              _c(
                "filters-drawer",
                {
                  attrs: {
                    "hide-search": true,
                    "is-busy": _vm.isBusy,
                    "filter-tags": _vm.activeFilterTags
                  },
                  on: {
                    "remove-tag": _vm.removeFilterTag,
                    submit: _vm.onSearch,
                    clear: _vm.onClearFilters
                  }
                },
                [
                  _c(
                    "b-col",
                    { attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Вакансии")
                      ]),
                      _vm._v(" "),
                      _c("vacancy-multi-select", {
                        ref: "vacancy_multi_select",
                        attrs: { id: "vacancy-multi-select" },
                        on: { onSelect: _vm.onSelectVacancy }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Дата публикации")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-start-opened-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.start_opened_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "start_opened_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.start_opened_date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "auto" } },
                            [_c("span", [_vm._v("—")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-end-opened-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.end_opened_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "end_opened_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.end_opened_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Дата первого выхода в смену")
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        { staticClass: "align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-start-closed-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.start_closed_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "start_closed_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.start_closed_date"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            { staticClass: "px-2", attrs: { cols: "auto" } },
                            [_c("span", [_vm._v("—")])]
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c("b-form-input", {
                                attrs: {
                                  id: "input-end-closed-date",
                                  size: "sm",
                                  type: "date"
                                },
                                model: {
                                  value: _vm.filters.end_closed_date,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.filters,
                                      "end_closed_date",
                                      $$v
                                    )
                                  },
                                  expression: "filters.end_closed_date"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Объекты")
                      ]),
                      _vm._v(" "),
                      _c("location-multi-select", {
                        ref: "location_multi_select",
                        attrs: { id: "location-multi-select" },
                        on: { onSelect: _vm.onSelectLocation }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Ответственные")
                      ]),
                      _vm._v(" "),
                      _c("user-multi-select", {
                        ref: "user_multi_select_assigned",
                        attrs: {
                          id: "user-multi-select-assigned",
                          title: "Ответственные"
                        },
                        on: { onSelect: _vm.onSelectUserAssigned }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Статус")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-statuses",
                          size: "sm",
                          options: _vm.statusOptions
                        },
                        model: {
                          value: _vm.filters.status,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "status", $$v)
                          },
                          expression: "filters.status"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "mt-1", attrs: { md: "6", cols: "12" } },
                    [
                      _c("label", { staticClass: "small text-muted" }, [
                        _vm._v("Сервис")
                      ]),
                      _vm._v(" "),
                      _c("b-form-select", {
                        attrs: {
                          id: "input-provider-id",
                          size: "sm",
                          options: _vm.providerOptions
                        },
                        model: {
                          value: _vm.filters.provider_id,
                          callback: function($$v) {
                            _vm.$set(_vm.filters, "provider_id", $$v)
                          },
                          expression: "filters.provider_id"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewMode === "table"
        ? _c("b-table", {
            ref: "recruit_job_postings",
            staticClass: "mb-0 text-small",
            attrs: {
              id: "recruit-job-postings",
              selectable: "",
              "select-mode": "single",
              selectedVariant: "success",
              striped: "",
              small: "",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              busy: _vm.isBusy,
              items: _vm.items,
              fields: _vm.renderedFields,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": "",
              "no-local-sorting": "",
              "sticky-header": "",
              "head-variant": "light"
            },
            on: {
              "update:busy": function($event) {
                _vm.isBusy = $event
              },
              "sort-changed": _vm.sortChanged,
              "row-dblclicked": _vm.onRowClicked
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "table-busy",
                  fn: function() {
                    return [
                      _c(
                        "div",
                        { staticClass: "text-center text-success my-2" },
                        [
                          _c("b-spinner", { staticClass: "align-middle" }),
                          _vm._v(" "),
                          _c("strong", [_vm._v("Загрузка")])
                        ],
                        1
                      )
                    ]
                  },
                  proxy: true
                },
                {
                  key: "cell(assigned)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getAssignedName(row.item.assigned)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(status)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.getStatusText(row.item.status)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(opened_date)",
                  fn: function(row) {
                    return [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.formatTableDate(row.item.opened_date)) +
                          "\n    "
                      )
                    ]
                  }
                },
                {
                  key: "cell(action)",
                  fn: function(row) {
                    return [
                      _c(
                        "b-dropdown",
                        {
                          attrs: { size: "sm", "no-caret": "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "button-content",
                                fn: function() {
                                  return [
                                    _c("font-awesome-icon", {
                                      attrs: { icon: "ellipsis-v" }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        },
                        [
                          _vm._v(" "),
                          _c(
                            "b-dropdown-item-button",
                            {
                              attrs: { variant: "success" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.showModal(row.item.id, true)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "mr-1",
                                attrs: { icon: "eye" }
                              }),
                              _vm._v("\n          Смотреть\n        ")
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.canEditRecruitJobPostings()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "primary" },
                                  on: {
                                    click: function($event) {
                                      return _vm.showModal(row.item.id, false)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "edit" }
                                  }),
                                  _vm._v("\n          Редактировать\n        ")
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canEditRecruitJobPostings()
                            ? _c(
                                "b-dropdown-item-button",
                                {
                                  attrs: { variant: "danger" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onRemove(row)
                                    }
                                  }
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: "trash" }
                                  }),
                                  _vm._v("\n          Удалить\n        ")
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              3200263146
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.viewMode === "kanban"
        ? _c("kanban", {
            attrs: {
              items: _vm.items,
              columns: _vm.kanbanColumns,
              "group-name": "recruit-job-postings"
            },
            on: { "status-updated": _vm.kanbanUpdateStatus },
            scopedSlots: _vm._u(
              [
                {
                  key: "card",
                  fn: function(ref) {
                    var item = ref.item
                    return [
                      _c(
                        "b-card",
                        {
                          staticClass: "kb-card p-2 bg-white shadow-sm rounded",
                          attrs: { "no-body": "" },
                          on: {
                            dblclick: function($event) {
                              return _vm.onRowClicked(item)
                            }
                          }
                        },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mb-1" },
                            [
                              _c("b-col", [
                                _c("strong", { staticClass: "text-primary" }, [
                                  _vm._v("#" + _vm._s(item.id))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "4" } },
                                [
                                  _c(
                                    "b-badge",
                                    { attrs: { variant: "white" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.formatTableDate(item.opened_date)
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "mb-2" },
                            [
                              _c("b-col", [
                                _c("strong", { staticClass: "text-primary" }, [
                                  _vm._v(
                                    "\n              #" +
                                      _vm._s(item.recruit_task_id) +
                                      "\n            "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(item.location_vacancy_name) +
                                      "\n            "
                                  )
                                ])
                              ])
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "small text-muted mb-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    staticStyle: { color: "green" },
                                    attrs: { icon: "map-marked-alt" }
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(item.location_name) +
                                      "\n          "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            { staticClass: "small text-muted mb-2" },
                            [
                              _c(
                                "b-col",
                                [
                                  _c("font-awesome-icon", {
                                    staticClass: "mr-1",
                                    attrs: { icon: "user" }
                                  }),
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(
                                        _vm.getAssignedName(item.assigned) ||
                                          "Не назначен"
                                      ) +
                                      "\n          "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("hr", { staticClass: "my-1" }),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { staticClass: "d-flex justify-content-end" },
                                [
                                  _c(
                                    "b-button",
                                    {
                                      staticClass: "p-0",
                                      attrs: { size: "sm", variant: "link" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onRowClicked(item)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              Открыть\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              4143886205
            )
          })
        : _vm._e(),
      _vm._v(" "),
      _c("pagination-footer", {
        attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
        on: {
          "update:perPage": function($event) {
            _vm.perPage = $event
          },
          "update:per-page": function($event) {
            _vm.perPage = $event
          },
          "page-click": _vm.onPagination,
          "per-page-change": _vm.onPerPageChange
        }
      }),
      _vm._v(" "),
      _c("DynamicTables", {
        attrs: {
          "storage-key": "recruitJobPostings_columns",
          "sidebar-fields": "sidebar-fields",
          "fields-model": _vm.fields,
          serviceEndField: _vm.serviceEndField,
          fieldKey: "id"
        },
        on: {
          "update:fieldsModel": function($event) {
            _vm.fields = $event
          },
          "update:fields-model": function($event) {
            _vm.fields = $event
          }
        }
      }),
      _vm._v(" "),
      _c("RecruitJobPosting", {
        ref: "recruit_job_posting",
        on: { refresh: _vm.getItems, "modal-closed": _vm.onModalClosed }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b974e4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b974e4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recruiting/RecruitJobPostings.vue
// module id = null
// module chunks = 